import { forumCategories } from '@/mocks/forumData';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '草榴论坛入口指南',
    url: window.location.origin,
    description: '草榴论坛官方入口与使用指南网站，为访客提供论坛最新入口地址、注册教程、版块介绍及安全使用指南。',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@caoliu-guide.com',
      contactType: 'customer service',
    },
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '关于我们 - 草榴论坛入口指南',
    description: '了解草榴论坛入口指南网站的品牌背景、用户口碑与联系方式。',
    url: `${window.location.origin}/about`,
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: `${window.location.origin}/` },
      { '@type': 'ListItem', position: 2, name: '关于我们' },
    ],
  };

  const testimonials = [
    {
      name: '论坛老用户',
      role: '注册会员 3年+',
      content: '这个导航网站帮我找到了稳定的论坛入口，再也不用担心找不到地址了。教程也很实用，推荐给新手朋友们。',
      rating: 5,
    },
    {
      name: '网络技术爱好者',
      role: '技术版块活跃用户',
      content: '网站的安全使用指南写得非常专业，很多实用的安全技巧，是每个论坛用户都应该阅读的内容。',
      rating: 5,
    },
    {
      name: '社区新人',
      role: '刚加入论坛',
      content: '作为一个刚接触论坛的新人，这个网站的教程对我帮助很大。注册教程一步步跟着做，很快就完成了。',
      rating: 5,
    },
    {
      name: '资深版主',
      role: '社区管理经验丰富',
      content: '作为长期参与社区管理的人，我很认可这个网站的定位——帮用户更快更好地找到和使用论坛，引导健康积极的社区参与。',
      rating: 5,
    },
  ];

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />

      <main className="min-h-screen pt-16">
        {/* About Header */}
        <section className="w-full bg-background-100 border-b border-background-200/70">
          <div className="max-w-3xl mx-auto px-4 md:px-6 py-10 md:py-14 text-center">
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              关于我们
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              草榴论坛入口指南是一个专注为用户提供草榴论坛访问指引的第三方导航网站，
              致力于帮助广大网友快速找到并顺利使用草榴论坛的全部功能。
            </p>
          </div>
        </section>

        {/* Brand Introduction */}
        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-5">
                  品牌故事
                </h2>
                <div className="space-y-4 text-sm text-foreground-700 leading-relaxed">
                  <p>
                    草榴论坛入口指南诞生于一个简单的初衷——帮助更多人轻松找到并访问草榴论坛。
                    作为国内知名的综合交流社区，草榴论坛汇聚了大量优质内容和活跃用户，
                    但由于网络环境的复杂性，入口地址时常变化，给许多用户带来了困扰。
                  </p>
                  <p>
                    我们的团队由一群热爱社区交流的技术爱好者和资深论坛用户组成，
                    凭借对网络技术的深入了解和对草榴论坛的深厚感情，
                    我们创建了这个导航平台，旨在：
                  </p>
                </div>
              </div>
              <div className="space-y-4">
                {[
                  { icon: 'ri-guide-line', title: '提供稳定入口', desc: '持续监测和更新草榴论坛入口地址，确保用户能够稳定访问' },
                  { icon: 'ri-book-open-line', title: '整理实用教程', desc: '编写详细的注册、使用和安全教程，帮助新手快速上手' },
                  { icon: 'ri-shield-check-line', title: '倡导安全使用', desc: '推广账号安全和隐私保护意识，营造安全的社区环境' },
                  { icon: 'ri-user-heart-line', title: '引导积极交流', desc: '传播社区文化和交流礼仪，促进健康积极的社区氛围' },
                ].map((item) => (
                  <div key={item.title} className="flex gap-3 p-3 bg-background-100 border border-background-200/70 rounded-lg">
                    <div className="w-9 h-9 flex items-center justify-center flex-shrink-0 rounded-lg bg-primary-100 text-primary-600">
                      <i className={`${item.icon} text-base`}></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                      <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="w-full py-14 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-10">
              数据一览
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
              {[
                { value: '50,000+', label: '月均访客' },
                { value: '120+', label: '教程文章' },
                { value: '6', label: '覆盖版块' },
                { value: '99.9%', label: '服务可用率' },
              ].map((stat) => (
                <div key={stat.label} className="text-center p-4 bg-background-50 border border-background-200/70 rounded-lg">
                  <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading mb-1">{stat.value}</div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-10">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {testimonials.map((item, index) => (
                <div
                  key={index}
                  className="bg-background-100 border border-background-200/70 rounded-lg p-5"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: item.rating }).map((_, i) => (
                      <span key={i} className="w-4 h-4 flex items-center justify-center text-primary-500">
                        <i className="ri-star-fill text-sm"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    &ldquo;{item.content}&rdquo;
                  </p>
                  <div className="flex items-center gap-2">
                    <div className="w-9 h-9 rounded-full bg-accent-100 text-accent-600 flex items-center justify-center text-sm font-medium">
                      {item.name[0]}
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{item.name}</p>
                      <p className="text-xs text-foreground-500">{item.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="w-full py-14 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-4">
              联系我们
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-10 max-w-xl mx-auto">
              如果您在使用本站过程中遇到任何问题，或有任何建议和反馈，欢迎通过以下方式与我们取得联系。
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-5 text-center">
                <div className="w-11 h-11 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                <p className="text-xs text-foreground-600">contact@caoliu-guide.com</p>
                <p className="text-xs text-foreground-500 mt-1">工作日24小时内回复</p>
              </div>

              <div className="bg-background-50 border border-background-200/70 rounded-lg p-5 text-center">
                <div className="w-11 h-11 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-refresh-line text-lg"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">内容更新</h3>
                <p className="text-xs text-foreground-600">入口地址持续更新中</p>
                <p className="text-xs text-foreground-500 mt-1">建议收藏本站随时查看</p>
              </div>

              <div className="bg-background-50 border border-background-200/70 rounded-lg p-5 text-center">
                <div className="w-11 h-11 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                  <i className="ri-information-line text-lg"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">免责声明</h3>
                <p className="text-xs text-foreground-600">本站为第三方导航网站</p>
                <p className="text-xs text-foreground-500 mt-1">与草榴论坛官方无直接关联</p>
              </div>
            </div>
          </div>
        </section>

        {/* Quick Nav */}
        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
              快速导航
            </h2>
            <p className="text-sm text-foreground-600 mb-8">选择您感兴趣的内容开始浏览</p>
            <div className="flex flex-wrap items-center justify-center gap-3">
              {forumCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer border ${
                    cat.color === 'primary'
                      ? 'bg-primary-500 text-white border-primary-500 hover:bg-primary-600'
                      : cat.color === 'accent'
                      ? 'bg-accent-500 text-white border-accent-500 hover:bg-accent-600'
                      : 'bg-secondary-500 text-white border-secondary-500 hover:bg-secondary-600'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
    </>
  );
}